<template lang="html">
  <div>
    <div class="comments" :ref="'comments'">
      <div>
        <Comment v-for="comment in comments" :content="comment" :key="comment.posted_on"
                 @comment:update="update_comment"/>
      </div>
      <br/>
    </div>
    <Comment @comment:send="create_comment"
             :content="{'text':null, 'who':$store.state.profile.data.fullname, 'avatar':$store.state.profile.data.avatar, 'direction':'left', 'posted_on':null}"
             :disabled="active == false"/>
  </div>
</template>

<script>
import Comment from "@/components/Comment.vue";
import tools from "@/tools.js";

export default {
  name: "StateComments",
  components: { Comment },
  props: {
    comments: Array,
    active: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      internal_comments: null
    };
  },
  watch: {
    comments(new_value, old_value) {
      if (new_value.length !== old_value.length) {
        this.internal_comments = tools.deep_copy(this.comments);
      }
    }
  },
  methods: {
    scroll_down() {
      const el = this.$refs && this.$refs.comments ? this.$refs.comments : null;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    },
    update_comment(data) {
      const index = this.internal_comments.findIndex(
        item => item.posted_on === data.posted_on && item.who === data.who
      );
      if (index !== -1) {
        this.internal_comments[index] = data;
        this.internal_comments[index].text = this.internal_comments[index].text.replace(/(?:\r\n|\r|\n)/g, "<br>");
        this.$emit("comments:updated", this.internal_comments);
      }
    },
    create_comment(data) {
      this.internal_comments.push(data);
      this.$emit("comments:added", this.internal_comments);
      this.scroll_down();
    }
  },
  updated() {
    this.scroll_down();
  },
  created() {
    this.internal_comments = tools.deep_copy(this.comments);
  },
  mounted() {
    this.scroll_down();
  }
};
</script>

<style scoped lang="scss">
.comments {
  /*max-height: 200px;*/
  overflow-y: hidden;
}
</style>
